const ITEM_EDIT_ALLOWS_CONTACT = 'account-edit-allows-contact';

export default {
	ITEM_EDIT_ALLOWS_CONTACT,
};
